import Joi from 'joi';
import {
	YEARS,
	SICKNESS_INSURANCE_MAXIMUM_PAYMENT,
	SICKNESS_INSURANCE_MINIMUM_PAYMENT,
} from '../LegalParameters/Constants';

const textTempl = (min, max) =>
	`Vyměřovací základ musí být celé kladné číslo mezi ${min} a ${max}!`;

export default Joi.object({
	monthlyInsurance: Joi.alternatives()
		.when('year', {
			is: 2019,
			then: Joi.number()
				.min(SICKNESS_INSURANCE_MINIMUM_PAYMENT[2019])
				.max(SICKNESS_INSURANCE_MAXIMUM_PAYMENT[2019])
				.error(() => ({
					message: textTempl(
						SICKNESS_INSURANCE_MINIMUM_PAYMENT[2019],
						SICKNESS_INSURANCE_MAXIMUM_PAYMENT[2019],
					),
				})),
		})
		.when('year', {
			is: 2018,
			then: Joi.number()
				.min(SICKNESS_INSURANCE_MINIMUM_PAYMENT[2018])
				.max(SICKNESS_INSURANCE_MAXIMUM_PAYMENT[2018])
				.error(() => ({
					message: textTempl(
						SICKNESS_INSURANCE_MINIMUM_PAYMENT[2018],
						SICKNESS_INSURANCE_MAXIMUM_PAYMENT[2018],
					),
				})),
		}),
	children: Joi.number()
		.integer()
		.positive()
		.min(1),
	year: Joi.valid(YEARS),
});
